module.exports = __webpack_public_path__ + "static/media/169.8e58bae1.jpg";